import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import { unitLabel } from '@common/services/unitUtils';
import { withStyles } from 'tss-react/mui';
import { unitResponsesStyles } from './styles';

const VcmUnitCheckModalMissingUnitDetail = ({
  classes,
  missingUnits,
  rejectUnitCodes,
  removeUnitCodes,
  onCodeChange
}) => {
  const rows = missingUnits.map((unit) => {
    const code = unit.code;
    return (
      <>
        <Grid size={4}>
          <Typography>{unitLabel(unit)}</Typography>
        </Grid>
        <Grid size={4} alignItems="stretch">
          <Radio
            className={classes.addMissingUnitsRadio}
            checked={rejectUnitCodes.includes(code)}
            onChange={() => { onCodeChange?.(code, 'reject');} }
          />
        </Grid>
        <Grid size={4} alignItems="stretch">
          <Radio
            className={classes.addMissingUnitsRadio}
            checked={removeUnitCodes.includes(code)}
            onChange={() => { onCodeChange?.(code, 'remove'); }}
          />
        </Grid>
      </>
    );
  });

  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <Typography variant="h6">Units missing from VCM</Typography>
      </Grid>
      <Grid size={12}>
        <Typography>
          <em>Educator Response Required</em> - The educator delivers this unit and a response is required for this VCM.
        </Typography>
        <Typography>
          <em>Not Required / Remove</em> - The Educator does not deliver this unit so it will be added to the Removed Unit list for this VCM.
        </Typography>
      </Grid>
      <Grid size={4}>
        <Typography><strong>Unit</strong></Typography>
      </Grid>
      <Grid size={4} justify="center">
        <Typography><strong>Educator Response Required</strong></Typography>
      </Grid>
      <Grid size={4} justify="center">
        <Typography><strong>Not Required / Remove</strong></Typography>
      </Grid>
      {rows}
    </Grid>
  );
};

export default withStyles(VcmUnitCheckModalMissingUnitDetail, unitResponsesStyles, {
  withTheme: true
});
